import { useEffect } from 'react';

function isEscapeKey(event) {
  return event.key === 'Escape' || event.keyCode === 27;
}

function hasVisibleModal() {
  return !!document.querySelector('.modal.show');
}

function panelOwnsFocus(panelRef) {
  const panel = panelRef && panelRef.current;
  const activeElement = document.activeElement;
  return !!(panel && activeElement && panel.contains(activeElement));
}

export function useFocusedUtilityEscape({ enabled, panelRef, onEscape }) {
  useEffect(() => {
    if (!enabled || typeof onEscape !== 'function') {
      return undefined;
    }

    const onKeyDown = (event) => {
      if (!isEscapeKey(event)) {
        return;
      }
      if (event.defaultPrevented) {
        return;
      }
      if (hasVisibleModal()) {
        return;
      }
      if (!panelOwnsFocus(panelRef)) {
        return;
      }

      event.preventDefault();
      onEscape();
    };

    document.addEventListener('keydown', onKeyDown, false);
    return () => {
      document.removeEventListener('keydown', onKeyDown, false);
    };
  }, [enabled, panelRef, onEscape]);
}
